import { PublicHeader } from '@/components/layout/PublicHeader';
import { PageMeta } from '@/components/seo/PageMeta';
import { BreadcrumbJsonLd, WebPageJsonLd } from '@/components/seo/JsonLd';
import { PublicFooter } from '@/components/layout/PublicFooter';
import { PageHeroSection } from '@/components/home/PageHeroSection';
import { BuildSkillsSection } from '@/components/home/BuildSkillsSection';
import { StatsSection } from '@/components/home/StatsSection';
import { ImageBreakSection } from '@/components/home/ImageBreakSection';
import { InteractiveLessonsSection } from '@/components/home/InteractiveLessonsSection';
import { FindLessonSection } from '@/components/home/FindLessonSection';
import { FeaturedVideosSection } from '@/components/home/FeaturedVideosSection';
import { FreeTrialSection } from '@/components/FreeTrialSection';

const homeHeadline = [
  { text: 'PLAY', color: '#FFFF00' },
  { text: '\n', color: 'white' },
  { text: 'WITH THE', color: 'white' },
  { text: '\n', color: 'white' },
  { text: 'MASTERS', color: 'white' },
];

export default function Index() {
  return (
    <div className="min-h-screen bg-background">
      <PageMeta
        title="Master Jazz with World-Class Tutorials | Tenacity Music"
        description="Learn jazz from professional musicians. HD video tutorials for drums, piano, and guitar with A/B looping, progress tracking, and personalized learning."
        path="/"
      />
      <WebPageJsonLd
        name="Tenacity Music - Master Jazz with World-Class Tutorials"
        description="Learn jazz from professional musicians. HD video tutorials for drums, piano, and guitar with A/B looping, progress tracking, and personalized learning."
        url="/"
      />
      <BreadcrumbJsonLd items={[{ name: 'Home', url: '/' }]} />
      <PublicHeader />

      <main className="pt-20">
        <PageHeroSection 
          headline={homeHeadline}
          paragraphText="From fundamentals to improvisation, learn jazz the way it was meant to be—authentic, expressive, and rooted in tradition."
          paragraphBoldText="Start Your Jazz Journey and Become a Master"
          paragraphMaxWidth="345px"
        />
        <BuildSkillsSection />
        <StatsSection />
        <ImageBreakSection />
        <InteractiveLessonsSection />
        <FindLessonSection />
        <FeaturedVideosSection />
        <FreeTrialSection />
      </main>

      <PublicFooter />
    </div>
  );
}